import { render, staticRenderFns } from "./nao-autorizado.vue?vue&type=template&id=710a82d8"
import script from "./nao-autorizado.vue?vue&type=script&lang=js"
export * from "./nao-autorizado.vue?vue&type=script&lang=js"
import style0 from "./nao-autorizado.vue?vue&type=style&index=0&id=710a82d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports